import React from 'react'
import Charcard from '../../molecules/Charcard'

export default function Charmainrole({title, data}) {
  return (
    <div className='h-full  mx-6 my-[30px] mb-[35px] md:mb-[20px]'>
      <Charcard
        title={title}
        content={data}
        primary
        charRole
      />
    </div>
  )
}
